export default "__VITE_ASSET__BLRwWYAh__"